import api, { CacheTagType } from "@/store/api";

interface AddMealRequestBody {
  calories?: number;
  comment?: string;
  description?: string;
  isNewFood?: boolean;
  mealType?: string;
  // e.g., "2025-12-19T12:00:00-08:00" (ISO 8601 format with timezone offset)
  occurredAt: string;
  patientExternalId: string;
}

interface AddMealResponse {
  smtEntryId: string;
}

const mealsApi = api.injectEndpoints({
  endpoints: (build) => ({
    addMeal: build.mutation<AddMealResponse, AddMealRequestBody>({
      // eslint-disable-next-line max-params
      invalidatesTags: (_result, error, arg) => {
        if (error) {
          return [];
        }

        // Only invalidate SMTSummary tag if meal was added successfully
        // SMTEntries tag is invalidated in useAddSMTEntry entry after an entry is added
        // ensuring that only the relevant cache entries are invalidated based on the patientExternalId
        return [{ id: arg.patientExternalId, type: CacheTagType.SMTSummary }];
      },
      query: (arg) => ({
        body: arg,
        method: "POST",
        url: `/assessments/family/patients/${arg.patientExternalId}/meals`,
      }),
    }),
  }),
});

const { useAddMealMutation } = mealsApi;

export type { AddMealRequestBody, AddMealResponse };

export { useAddMealMutation };
